
import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { FormControl, FormItem, FormLabel } from "@/components/ui/form";
import { OfferingOption } from '../../hooks/useOfferingOptions';

interface MultiColumnCheckboxesProps {
  options: OfferingOption[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
}

export const MultiColumnCheckboxes: React.FC<MultiColumnCheckboxesProps> = ({
  options,
  selectedValues,
  onChange,
}) => {
  const handleCheckboxChange = (value: string, checked: boolean) => {
    const newSelectedValues = checked
      ? [...selectedValues, value]
      : selectedValues.filter(v => v !== value);
    
    onChange(newSelectedValues);
  };

  // Group options into columns (3 columns)
  const columnCount = 3;
  const itemsPerColumn = Math.ceil(options.length / columnCount);
  const columns: OfferingOption[][] = [];
  
  for (let i = 0; i < columnCount; i++) {
    columns.push(options.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn));
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {columns.map((column, columnIndex) => (
        <div key={columnIndex} className="space-y-2">
          {column.map((option) => (
            <div key={option.value} className="flex items-center space-x-2">
              <Checkbox
                id={`offering-${option.value}`}
                checked={selectedValues.includes(option.value)}
                onCheckedChange={(checked) => 
                  handleCheckboxChange(option.value, checked === true)
                }
              />
              <label
                htmlFor={`offering-${option.value}`}
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
